export default __webpack_public_path__ + "static/media/why-agifly.429809df.svg";